export const pageContainer =
  'pos-bg-image flex h-full w-full bg-cover bg-center bg-no-repeat md:px-[20px] lg:px-[40px] md:pt-[130px] md:pb-[90px]'

export const backdropWrapper =
  'm-auto flex w-full flex-col justify-center bg-[rgba(255,255,255,1)] pt-12 md:bg-[rgba(255,255,255,0.55)] md:px-3.5 lg:px-16 md:pt-16 md:pb-20 lg:max-w-screen-3xl'

export const backdropHeader = 'flex flex-col items-center justify-center'

export const iconWrapper = 'flex max-w-[90%] pb-4'

export const headerTitle =
  'text-28 font-Roboto tracking-0 m-auto md:mb-10 block w-fit text-black font-bold'

export const teaserContainer = 'mb-16 flex flex-col p-5 md:flex-row md:p-0'

export const linkWrapper =
  'relative mt-5 block h-full shrink-0 grow-0 basis-4/12 px-3.5 opacity-100 md:mt-0 md:max-w-[33.33%] '

export const image = 'h-full w-full'

export const teaserTextWrapper =
  'flex h-16 items-center justify-center bg-black md:h-12'

export const teaserText =
  'text-14 tracking-0 font-Roboto uppercase text-white font-bold'

export const welcomeOfferLinkWrapper =
  'ml-3.5 pl-[20px] md:pl-0 w-fit mb-16 md:mb-0'

export const welcomeOfferLink =
  'text-12 font-Roboto tracking-0 text-black after:shadow-black'

export const agentModal =
  'flex !w-[95%] md:!w-[82vw] md:max-w-screen-3xl animate-appear !p-8 md:!px-12 md:!py-10'

export const agentFormWrapper = 'flex-col items-center justify-start'

export const agentFormSubmitButton =
  'md:w-fit text-16 mt-4 mb-4 w-full py-8 px-20 md:mt-8'
